import React, { useCallback } from 'react'
import { useSelector,useDispatch } from 'react-redux'

import ComAlert from '@/components/comAlert'
// import * as alertActions from '@/store/actions/alert'
import { alertHide } from '@/store/actions'
import './index.scss'

export default function(props) {

  let { data: alertInfo } = useSelector(state => state.alert)
  const dispatch = useDispatch();
  const closeAlert = useCallback(() => {
    dispatch(alertHide())
  }, [])  
  return (
    <div className='main-box'>
      {
        props.children
      }
      {
        alertInfo && <ComAlert info={alertInfo} closeAlert={closeAlert}/>
      }
    </div>
  )
}
